const COMPLETED_KEY = "completed_tests";

async function fetchCompletedTestsFromServer(): Promise<string[]> {
  try {
    const response = await fetch("/api/user/completed-tests", {
      method: "GET",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      return [];
    }

    const data = await response.json();
    return Array.isArray(data.completedTestIds) ? data.completedTestIds : [];
  } catch {
    return [];
  }
}

export async function getCompletedTests(): Promise<string[]> {
  if (typeof window === "undefined") return [];

  try {
    const serverTests = await fetchCompletedTestsFromServer();
    if (serverTests.length > 0) {
      localStorage.setItem(COMPLETED_KEY, JSON.stringify(serverTests));
      return serverTests;
    }
  } catch {
    // ignore network errors, fall back to localStorage
  }

  try {
    const data = localStorage.getItem(COMPLETED_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export async function markTestCompleted(testId: string): Promise<void> {
  if (typeof window === "undefined") return;

  try {
    const completed = await getCompletedTests();
    if (!completed.includes(testId)) {
      const updated = [...completed, testId];
      localStorage.setItem(COMPLETED_KEY, JSON.stringify(updated));
    }
  } catch {
    // ignore storage errors
  }
}

export async function isTestCompleted(testId: string): Promise<boolean> {
  const completed = await getCompletedTests();
  return completed.includes(testId);
}
